import React, { FC } from 'react';
import { DeepzoomStatus } from '../../../shared/models/deepzoomStatus.enum';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faSpinner, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './DeepzoomCreationStatus.module.scss';

interface DeepzoomCreationStatusProps {
  status: DeepzoomStatus;
}

const DeepzoomCreationStatus: FC<DeepzoomCreationStatusProps> = ({ status }) => {
  switch (status) {
    case DeepzoomStatus.notStarted:
      return (
        <span className={styles.sequenceStatus}>
          <FontAwesomeIcon icon={faPlay} className={styles.ready} />
          Not started
        </span>
      );
    case DeepzoomStatus.inProgress:
      return (
        <span className={styles.sequenceStatus}>
          <FontAwesomeIcon icon={faSpinner} className={`${styles.inProgress} ${styles.rotate}`} />
          In Progress
        </span>
      );
    case DeepzoomStatus.finished:
      return (
        <span className={styles.sequenceStatus}>
          <FontAwesomeIcon icon={faCheck} className={styles.done} />
          Finished
        </span>
      );
    case DeepzoomStatus.failed:
      return (
        <span className={styles.sequenceStatus}>
          <FontAwesomeIcon icon={faTimes} className={styles.failed} />
          Failed
        </span>
      );
    default:
      return <span />;
  }
};

export default DeepzoomCreationStatus;
